import { SearchContext } from "@search/context/SearchContext";
import { type SearchStore } from "@search/store/types";
import { useContext } from "react";
import { useStore } from "zustand";

export function useSearchStore<T>(selector?: (state: SearchStore) => T) {
  const store = useContext(SearchContext);

  if (!store) {
    throw new Error("Missing SearchContext.Provider in the tree");
  }

  return useStore(store, selector!);
}
